'use client';

import Button from '@/components/ui/Button';
import { cn } from '@/lib/utils/utils';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { useGetJobInsight } from '../../api/jobs.queries';
import { useJobInsightJobMetrics } from '@/features/jobs/hooks/useJobInsightJobMetrics';
import { insightCopy } from './insightCopy';
import { ZangiaPlusInsightView } from './ZangiaPlusInsightView';

export default function ZangiaPlusComponent({
  isEnglish = false,
  jobId,
  jobDetailKey,
  jobTime: jobTimeProp,
  showCollapseButton = false,
}: {
  isEnglish?: boolean;
  jobId: number;
  /** Зар detail (`getJobDetail`) — code эсвэл id */
  jobDetailKey?: string | number;
  /** Detail-ийн `time` (зар нийтэлсэн); өгөөгүй бол detail-аас татна */
  jobTime?: number | string;
  showCollapseButton?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(true);
  const detailKey = jobDetailKey ?? jobId;
  const { jobTime, isJobDetailLoading } = useJobInsightJobMetrics({
    jobDetailKey: detailKey,
    jobTime: jobTimeProp,
  });
  const { data: insightData, isLoading: isInsightLoading } =
    useGetJobInsight(jobId);
  const data = insightData?.data;
  const t = isEnglish ? insightCopy.en : insightCopy.mn;
  const isLoading = isInsightLoading || isJobDetailLoading;

  if (isLoading) {
    return (
      <section className="my-6 overflow-hidden rounded-xl border border-gray-200 bg-white p-5">
        <div className="mb-3 h-6 w-28 animate-pulse rounded-lg bg-gray-200" />
        <div className="mb-2 h-5 w-64 max-w-full animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-full max-w-md animate-pulse rounded bg-gray-100" />
      </section>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <section className="my-6 overflow-hidden rounded-xl border border-gray-200 bg-white">
      <ZangiaPlusInsightView
        data={data}
        jobTime={jobTime}
        isEnglish={isEnglish}
        collapsed={showCollapseButton && !isOpen}
        animateCollapse={showCollapseButton}
        headerAction={
          showCollapseButton ? (
            <Button
              type="button"
              variant="outline"
              aria-expanded={isOpen}
              aria-label={isOpen ? t.collapse : t.expand}
              onClick={() => setIsOpen((open) => !open)}
              className="shrink-0 p-0 border-none h-auto"
            >
              <ChevronDown
                className={cn(
                  'h-auto w-5 text-gray-500 transition-transform duration-300 ease-out',
                  isOpen && 'rotate-180'
                )}
              />
            </Button>
          ) : null
        }
      />
    </section>
  );
}
